import { useQuery } from '@tanstack/react-query';
import { fetchLookupActiveLocations } from '@api';
import { useSelector } from 'react-redux';
import { getGeneralSlice } from '@store/features';

export const useLookupActiveLocations = () => {
  const { segment, operatorType, commercialCategoryType } = useSelector(getGeneralSlice);
  return useQuery({
    queryKey: [
      'lookupActiveLocations',
      {
        segmentTypeId: segment?.id,
        commercialCategoryId: commercialCategoryType,
        operatorTypeId: operatorType,
        geoType: 0
      }
    ],
    enabled: !!segment,
    placeholderData: [],
    queryFn: ({ signal, queryKey }) =>
      fetchLookupActiveLocations(signal, queryKey[1])
        .then((resp) => resp)
        .catch(() => [])
  });
};
